import React from "react";
import PropTypes from "prop-types";
import store from "../../../state/store";
import {
  ETHINICITES_ABBREVIATIONS_TO_ETHNICITIES,
  SEX_ABBREVIATIONS_TO_SEX,
} from "../../../common/helpers/Constant";

const SingleValueChart = (props) => {
  const { title, data } = props;
  if (!Array.isArray(data)) {
    return null;
  }
  const highlightChart = (value) => {
    const state = store.getState();
    const variantQueryModeParams = state.variantQueryMode;
    let searchQueries = [];
    if (
      variantQueryModeParams &&
      variantQueryModeParams.cancer_type &&
      variantQueryModeParams.cancer_type.length > 0
    ) {
      searchQueries = searchQueries.concat(variantQueryModeParams.cancer_type);
    }
    if (
      variantQueryModeParams &&
      variantQueryModeParams.tissue_type &&
      variantQueryModeParams.tissue_type.length > 0
    ) {
      searchQueries = searchQueries.concat(variantQueryModeParams.tissue_type);
    }
    if (variantQueryModeParams && variantQueryModeParams.ethnicity) {
      const ethnicityFromAbbreviation =
        ETHINICITES_ABBREVIATIONS_TO_ETHNICITIES[
          variantQueryModeParams.ethnicity
        ];
      searchQueries = searchQueries.concat(ethnicityFromAbbreviation);
    }
    if (variantQueryModeParams && variantQueryModeParams.sex) {
      const sexFromAbbreviation =
        SEX_ABBREVIATIONS_TO_SEX[variantQueryModeParams.sex];
      searchQueries = searchQueries.concat(sexFromAbbreviation);
    }

    let finalvalue = value;
    searchQueries.forEach((searchQuery) => {
      const valueSanitized = value.toLowerCase();
      const searchQuerySanitized = searchQuery.toLowerCase();
      if (valueSanitized.includes(searchQuerySanitized)) {
        finalvalue = (
          <i className="tw-not-italic tw-inline-block tw-text-white tw-py-0 tw-px-1 tw-bg-orange-401 tw-bg-opacity-80">
            {value}
          </i>
        );
      }
    });
    return finalvalue;
  };

  const { key, value } = data[0];
  return (
    <div className="varsome_table">
      <table>
        <thead>
          <tr>
            <th>{title}</th>
            <th>Samples</th>
            <th>%</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="center">
              <span>{highlightChart(key)}</span>
            </td>
            <td className="center">{value}</td>
            <td className="center">100</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

SingleValueChart.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, value: PropTypes.number })
  ).isRequired,
};

export default SingleValueChart;
